import {CompaniesPresenter} from "@modules/onBoarding/application/port/output/CompaniesPresenter";
import {CompaniesViewModel} from "@modules/onBoarding/presentation/viewModel/CompaniesViewModel";
import {Company} from "@modules/onBoarding/domain/Company";
import {CompanyViewModel} from "@modules/onBoarding/presentation/viewModel/CompanyViewModel";

export class CompaniesViewModelPresenter implements CompaniesPresenter<CompaniesViewModel> {

    display(companies: Company[]): CompaniesViewModel {
        const companyViewModels: CompanyViewModel[] = companies.map(company => {
            return new CompanyViewModel(
               this.getCompanyId(company),
                this.getCompanyName(company),
                company.address,
                company.postcode,
                company.city
           );
        });

        return new CompaniesViewModel(
            'Please select your company from the list below',
            companyViewModels,
            'My company is not listed',
            'Confirm selection'
        );
    }

    private getCompanyId(company: Company): string {
        const isEuropeanVATNumberValid = company.europeanVatNumber != null
            && company.europeanVatNumber.length > 4;

        return isEuropeanVATNumberValid ?
            company.europeanVatNumber
            :
            company.id
        ;
    }

    private getCompanyName(company: Company): string {
        let companyName = '';

        if (company.internationalCompanyName && company.internationalCompanyName.trim()) {
            companyName = company.internationalCompanyName.trim();
        }

        if (company.companyName && company.companyName.trim() && company.companyName.trim() !== companyName) {
            if (companyName) {
                companyName += ' / ';
            }

            companyName += company.companyName.trim();
        }

        return companyName;
    }
}
